/**
 * Wrapper for the comment list
 */

// Import statements
import React, {Component} from "react"

/**
 * Define the comment wrapper class
 */
class CommentWrapper extends Component {

    // render the class
    render(props) {

        // return the information
        return (
            <ul className={(this.props.child === 'true' ? `children` : `comment-list media-list`)}>
                {this.props.children}
            </ul>
        )
    }
}

/**
 * Export the CommentWrapper variable
 */
export default CommentWrapper
